export const ARTWORK = 'ARTWORK';
export const ARTIST = 'ARTIST';
